import React from 'react';

import { makeStyles } from '@gogame/components';

const useStyles = makeStyles((theme) => ({
  placeholder: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    color: theme.palette.text.secondary,
  },
}));
const NoDataPlaceholder = () => {
  const classes = useStyles();

  return (
    <span className={classes.placeholder}>
      Please choose one of your Presets or select metrics, filters and graph
      settings, in order to load data.
      <span>Please note that data will load, only once you click “Apply”.</span>
    </span>
  );
};

export default NoDataPlaceholder;
